import React from 'react';
import styles from '../styles/NotFound.module.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary] Uncaught render error:', error, info?.componentStack);
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return (
            <main className={styles.page}>
                <span className={styles.code}>Ups</span>
                <h1>Algo ha ido mal en esta pagina</h1>
                <p>
                    No es tu conexion, es un fallo nuestro. Recarga la pagina o vuelve a la portada;
                    ya hemos registrado el error.
                </p>
                <div className={styles.actions}>
                    <button type="button" className={styles.primaryButton} onClick={() => window.location.reload()}>
                        Recargar
                    </button>
                    <a href="/" className={styles.secondaryButton}>Volver al inicio</a>
                </div>
            </main>
        );
    }
}

export default ErrorBoundary;
